import { useState, useEffect } from 'react';

const CloudCustomizationTab = ({ isNameEditable, isGroupEditable, onSave, saving }) => {
    const [displayName, setDisplayName] = useState(isNameEditable);
    const [group, setGroup] = useState(isGroupEditable);

    // Sync local state when props change (campus switch / reload)
    useEffect(() => {
        setDisplayName(isNameEditable);
        setGroup(isGroupEditable);
    }, [isNameEditable, isGroupEditable]);

    const isDirty = displayName !== isNameEditable || group !== isGroupEditable;

    const handleSave = () => {
        onSave({ isNameEditable: displayName, isGroupEditable: group });
    };

    const handleCancel = () => {
        setDisplayName(isNameEditable);
        setGroup(isGroupEditable);
    };

    return (
        <div className="pp-section">
            <div className="pp-section__header">
                <div>
                    <h2 className="pp-section__title">Customization Settings</h2>
                    <p className="ss-section-desc">
                        Controls which attributes caregivers can change themselves.
                    </p>
                </div>
                {isDirty ? (
                    <div className="pp-section__actions">
                        <button className="dp-btn dp-btn--cancel" onClick={handleCancel}>
                            Cancel
                        </button>
                        <button className="dp-btn dp-btn--primary" disabled={saving} onClick={handleSave}>
                            {saving ? 'Saving...' : 'Save Changes'}
                        </button>
                    </div>
                ) : null}
            </div>
            <div className="pp-section__body">
                <div className="ss-toggle-row">
                    <div className="ss-toggle-row__info">
                        <p className="ss-toggle-row__title">Display Name</p>
                        <p className="ss-toggle-row__desc">
                            Allow caregivers to edit the display name on resident profiles.
                        </p>
                    </div>
                    <div className="ss-toggle-row__control">
                        <div
                            className={`ss-toggle__track${displayName ? ' is-active' : ''}`}
                            onClick={() => setDisplayName(!displayName)}
                        >
                            <div className="ss-toggle__knob" />
                        </div>
                    </div>
                </div>

                <div className="ss-toggle-row">
                    <div className="ss-toggle-row__info">
                        <p className="ss-toggle-row__title">Group</p>
                        <p className="ss-toggle-row__desc">
                            Allow caregivers to edit the group assignment on resident profiles.
                        </p>
                    </div>
                    <div className="ss-toggle-row__control">
                        <div
                            className={`ss-toggle__track${group ? ' is-active' : ''}`}
                            onClick={() => setGroup(!group)}
                        >
                            <div className="ss-toggle__knob" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CloudCustomizationTab;
